import { useQuery } from '@apollo/client';

import { FeatureName, TeamMemberRole } from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import useCompanyContext from 'common/hooks/useCompanyContext';
import { hasRole } from 'features/Team/utils';

import { TeamMembersCountDocument } from './teamMembersCount.gql';

const useTeamMembersCount = () => {
  const { companyProfileId } = useCompanyContext();

  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  if (!companyProfileId) {
    throw new Error("'companyProfileId' is undefined in 'useTeamMembersCount'");
  }

  const { data, ...hook } = useQuery(TeamMembersCountDocument, {
    skip: !canAccessFeature({ name: FeatureName.Paymentcards }),
    variables: { companyProfileId },
  });

  const teamMembersCount =
    data?.viewer.company.teamMembers.edges.filter(
      (teamMember) =>
        hasRole(teamMember.node, TeamMemberRole.Admin) ||
        hasRole(teamMember.node, TeamMemberRole.Employee),
    ).length || 0;
  const isUniqueMember = teamMembersCount === 0;

  return {
    isUniqueMember,
    teamMembersCount,
    ...hook,
  };
};

export default useTeamMembersCount;
